import {
  GetAnualidadProyectosOptions,
  PostCalcularComisionesSemestral,
  GetCalculoSemestralAceptable
} from "../../../reducers/comisionAnualidad";
import * as actions from "../../../actions/comisionAnualidad";
import { Preview } from "../../../../types/IAction";

export interface ProcesoSemestralDispatcher {
  getProyectosOptions: () => Promise<Preview<GetAnualidadProyectosOptions>>;
  postCalcularComisionesSemestral: (
    periodo: string,
    metaChater?: number
  ) => Promise<Preview<PostCalcularComisionesSemestral>>;
  getCalculoSemestralAceptable: () => Promise<
    Preview<GetCalculoSemestralAceptable>
  >;
}

export const procesoSemestralDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ProcesoSemestralDispatcher = dispatch => ({
  getProyectosOptions: () => {
    return dispatch(actions.getProyectosOptions());
  },
  postCalcularComisionesSemestral: (periodo: string, metaChater?: number) => {
    return dispatch(
      actions.postCalcularComisionesSemestral(periodo, metaChater)
    );
  },
  getCalculoSemestralAceptable: () => {
    return dispatch(actions.getCalculoSemestralAceptable());
  }
});
